// $(document).ready(function () {
//   function handleCollapsible() {
//     $('body').off('click.collapsible'); 
//     if ($(window).width() > 768) {
//       $('body').on('click.collapsible', '.Collapsible__Button, .plus, .minus', function (e) {
//         e.preventDefault();
//         let $targetButton = $(this).closest('.custom_plus_minus').find('.Collapsible__Button');
//         let $inner = $targetButton.closest('.custom_plus_minus').next();
//         let $plus = $targetButton.parent().find('.plus');
//         let $minus = $targetButton.parent().find('.minus');
//         if ($inner.is(':visible')) {
//           $inner.hide();
//           $plus.show();
//           $minus.hide();
//         } else {
//           $inner.show();
//           $plus.hide();
//           $minus.show();
//         }
//       });
//     }
//   }
//   handleCollapsible();
//   $(window).on('resize', handleCollapsible); 
// });

$(document).ready(function () {
function handleCollapsible() {
  $('body').off('click.collapsible'); 
  $('body').on('click.collapsible', '.Collapsible__Button, .plus, .minus', function (e) {
    e.preventDefault();
    let $targetButton = $(this).closest('.custom_plus_minus').find('.Collapsible__Button');
    let $inner = $targetButton.closest('.custom_plus_minus').next();
    let $plus = $targetButton.parent().find('.plus');
    let $minus = $targetButton.parent().find('.minus');
    if ($inner.is(':visible')) {
      $inner.hide();
      $plus.show();
      $minus.hide();
    } else {
      $inner.show();
      $plus.hide();
      $minus.show();
    }
  });
}
handleCollapsible();
$(window).on('resize', handleCollapsible); 
});

//Started color swatches code

function initVariantSwatches() {
const containers = document.querySelectorAll('.variant-swatches-container');
containers.forEach(container => {
  if (container.dataset.swatchesInit === 'true') return;
  container.dataset.swatchesInit = 'true';

  const swatches = container.querySelector('.swatches');
  const prev = container.querySelector('.prev');
  const next = container.querySelector('.next');

  if (!swatches || !prev || !next) return;

  const swatchWidth = 40;
  const visibleSwatches = 5;
  let scrollPosition = 0;

  prev.addEventListener('click', () => {
    scrollPosition -= swatchWidth;
    if (scrollPosition < 0) scrollPosition = 0;
    swatches.style.transform = `translateX(-${scrollPosition}px)`;
  });

  next.addEventListener('click', () => {
    const maxScroll = swatches.scrollWidth - (swatchWidth * visibleSwatches);
    scrollPosition += swatchWidth;
    if (scrollPosition > maxScroll) scrollPosition = maxScroll;
    swatches.style.transform = `translateX(-${scrollPosition}px)`;
  });
});
}
initVariantSwatches(); 
const observer = new MutationObserver(() => {
initVariantSwatches();
});

observer.observe(document.body, {
childList: true,
subtree: true
});

//image slide animations code 
$(function () {
  function initSlick($slider) {
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;
    $slider.slick({
      arrows: true,
      infinite: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 400,
      autoplay: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev">‹</button>',
      nextArrow: '<button type="button" class="slick-next">›</button>'
    });
    const $wrapper = $slider.closest('.ProductItem__ImageWrapper');
    let userInteracted = false;
    $slider.on('click', '.slick-arrow', () => userInteracted = true);
    $wrapper.off('mouseenter mouseleave').on('mouseenter', function () {
      if (!userInteracted) $slider.slick('slickGoTo', 1);
    }).on('mouseleave', function () {
      if (!userInteracted) $slider.slick('slickGoTo', 0);
    });
    $slider.on('afterChange init', function (e, slick, current) {
      const total = slick.$slides.length;
      $slider.find('.slick-prev').prop('disabled', !current);
      $slider.find('.slick-next').prop('disabled', current === total - 1);
      if (e.type === 'init' && total <= 1)
        $slider.find('.slick-prev, .slick-next').prop('disabled', true);
    });
  }
  function initAllSliders() {
    $('.product-slick').each(function () {
      const $this = $(this);
      if (!$this.data('original-slides')) {
        $this.data('original-slides', $this.html());
      }
      initSlick($this);
    });
  }
  let debounceTimer;
  function reInitAfterAjax() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      initAllSliders();
    }, 500);
  }
  initAllSliders();
  const observer = new MutationObserver(() => reInitAfterAjax());
  const container = document.querySelector('.collection__product-grid') || document.body;
  observer.observe(container, { childList: true, subtree: true });
  $(document).on('change', '.Linklist__Checkbox', function () {
    reInitAfterAjax();
  });
  $(document).on('shopify:section:load ajaxComplete', function () {
    reInitAfterAjax();
  });
  $(document).on('click', '.color-swatch', function (e) {
    e.preventDefault();
    const selected = ($(this).attr('title') || '').trim().toLowerCase().replace(/\s+/g, '-');
    const $slider = $(this).closest('.ProductItem').find('.product-slick');
    if (!$slider.length) return;
    if ($slider.hasClass('slick-initialized')) {
      try { $slider.slick('unslick'); } catch (err) {}
    }
    $slider.html($slider.data('original-slides'));
    $slider.find('div').each(function () {
      const alt = ($(this).find('img').attr('alt') || '').trim().toLowerCase().replace(/\s+/g, '-');
      if (!alt.includes(selected)) $(this).remove();
    });
    initSlick($slider);
    $slider.slick('slickGoTo', 0);
  });
  $(document).on('click', '.slick-arrow', function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

});


// here we write a code for variant title 

 $(document).on('click', '.color-swatch', function () {
  let titlevalue = $(this).attr('title');
  let variantprice = $(this).attr('product-variant-price');
  let variantcompareprice = $(this).attr('product-variant-compare-price');
  let variantdiscount = $(this).attr('product-variant-discount');
  let $product = $(this).closest('.ProductItem');
  let cstmVariantattr = $product.find('.cstm-variant');
  cstmVariantattr.text(titlevalue);
  let $cstmprice = $product.find('.ProductItem__Price.3');
  let $cstmcompareprice = $product.find('.ProductItem__Price.4');
  let $cstmdiscount = $product.find('.ProductMeta__Price.Price--discount');

  if (variantcompareprice && variantcompareprice.trim() !== '') {
    $cstmprice.text(variantprice).show();
    $cstmcompareprice.text(variantcompareprice).show();
    $cstmdiscount.text(variantdiscount).hide();
  } else {
    $cstmprice.text(variantprice).show();
    $cstmcompareprice.hide();
    $cstmdiscount.hide();
  }
});

// active filter functionality
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.ActiveFilters__Tag');
  if (!btn) return;

  const param = btn.dataset.filterParam;
  const value = btn.dataset.filterValue;

  const selector =
    'input[name="' + CSS.escape(param) + '"][value="' + CSS.escape(value) + '"]';

  const checkbox = document.querySelector(selector);

  if (checkbox) {
    checkbox.checked = false;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
});



  $(document).on("click", ".Popover__Value[data-action='select-value']", function () {
    var selectedValue = $(this).data("value");
    var selectedText = $(this).text().trim();
    $(".selected-sort-text").text(selectedText);
    setTimeout(() => {
        $("[data-action='close-popover']").trigger("click");
    }, 200);
});


// JS added to show loader image on PLP ATC button click.

document.addEventListener("click", function (e) {
  const atcButton = e.target.closest(".addtocart_button");
  if (!atcButton) return;

  const atcText = atcButton.querySelector(".atc-text");
  const atcLoader = atcButton.querySelector(".atc-loader");

  if (!atcText || !atcLoader) return;

  // show loader
  atcText.style.display = "none";
  atcLoader.style.display = "inline-block";
  atcButton.classList.add("new-padding");
  atcButton.setAttribute("disabled", "disabled");

  // reset after 2 seconds
  setTimeout(function () {
    atcLoader.style.display = "none";
    atcText.style.display = "inline-block";
    atcButton.classList.remove("new-padding");
    atcButton.removeAttribute("disabled");
  }, 2000);
});



